/**
 * 콜랩 상세 부품(2.0 · 3.0 콜랩 모두 3.0 화면) — 조립은 라우트(`app/collabs/[id]/_detail`)가 한다.
 * @description 웹은 보기 전용이다. 누를 수 있는 것은 앱으로 가는 길(하단 버튼 · 참여자 줄 · 작품 칸 ·
 *   스레드 글 · `See the rest in the app`)과 공유뿐이다.
 */
export { default as CollabV3Analytics } from "./CollabV3Analytics";
export { default as CollabV3AppCta } from "./CollabV3AppCta";
export { default as CollabV3CheckinCard } from "./CollabV3CheckinCard";
export { default as CollabV3Cover } from "./CollabV3Cover";
export { default as CollabV3FeeCard } from "./CollabV3FeeCard";
export { default as CollabV3FundingCard } from "./CollabV3FundingCard";
export { default as CollabV3HostNote } from "./CollabV3HostNote";
export { default as CollabV3HostRow } from "./CollabV3HostRow";
export { default as CollabV3ShareButton } from "./CollabV3ShareButton";
export { default as CollabV3ThreadSection } from "./CollabV3ThreadSection";
export { CollabV3TimeZoneProvider } from "./CollabV3TimeZone";
export { default as CollabV3TitleGroup } from "./CollabV3TitleGroup";
export { default as CollabV3WhereWhen } from "./CollabV3WhereWhen";
export { default as CollabV3WorksCard } from "./CollabV3WorksCard";
